module.exports = __webpack_public_path__ + "img/3.4.a8ba0de5.png";